import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { CancelDigitalSignatureProcessClientResponse } from '../@types/CancelDigitalSignatureProcess'

type Store = {
  cancelDigitalSignatureProcess: CancelDigitalSignatureProcessClientResponse | null
  setCancelDigitalSignatureProcess: (
    value: CancelDigitalSignatureProcessClientResponse,
  ) => void
}

export const useCancelDigitalSignatureProcessStore = create<Store>()(
  devtools(
    (set) => ({
      cancelDigitalSignatureProcess: null,
      setCancelDigitalSignatureProcess: (cancelDigitalSignatureProcess) =>
        set({ cancelDigitalSignatureProcess }),
    }),
    { name: 'CancelDigitalSignatureProcessStore' },
  ),
)
